module.exports = __webpack_public_path__ + "img/图层 31@2x.d1616564.png";